import * as Models from "..";

export interface IInvoiceSubmissionModel {
  invoiceNumber: string;
  document: Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel;
  igsCustomerNumber: string;
}

export class InvoiceSubmissionModel implements IInvoiceSubmissionModel {
  public invoiceNumber: string;
  public document = new Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel();
  public igsCustomerNumber: string;

  constructor(igsCustomerNumber: string) {
    this.igsCustomerNumber = igsCustomerNumber;
    this.document = new Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel();
  }
}

export class InvoiceDetails {
  public invoiceAmount: number;
  public invoiceNumber: string;
  public isAutoGeneratedInvoice: boolean;
  public isPartnerInvoiceAutoGenerated: boolean;
}
